// pages/allergy/AllergyCreate.tsx
import React, { useEffect, useState } from "react";
import { Card, Input, Button, Flex, Checkbox, message } from "antd";
import { useCreateAllergyMutation } from "./allergy.service";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux"; // ✅ ADD
import LocationSelector from "../../components/LocationSelector"; // ✅ ADD
import "./style.css";

const allergyType = [
  "celery",
  "gluten",
  "crustaceans",
  "eggs",
  "fish",
  "lupin",
  "milk",
  "molluscs",
  "mustard",
  "nuts",
  "peanuts",
  "sesame seeds",
  "soya",
  "sulphur dioxide",
];

export default function AllergyCreate() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.app.user); // ✅ ADD

  // ✅ Location state
  const [locationId, setLocationId] = useState(null);

  const [allergyUpdate, setAllergyUpdate] = useState([]);
  const [allergyDish, setAllergyDish] = useState("");

  const [requestCreateAllergy, { isSuccess, isLoading }] = useCreateAllergyMutation();

  // ✅ Set initial location from user
  useEffect(() => {
    const locId = user?.activeLocationId || user?.restaurantId;
    setLocationId(locId);
  }, [user]);

  // ✅ Handle location change
  const handleLocationChange = (newLocationId) => {
    setLocationId(newLocationId);
  };

  const handleCreateAllergy = () => {
    if (!locationId) {
      toast.error("Please select a location first");
      return;
    }

    if (!allergyDish || allergyDish === "") {
      toast.error("Type in dish");
      return;
    }

    requestCreateAllergy({
      name: allergyDish,
      allergens: allergyUpdate,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setAllergyUpdate([]);
      setAllergyDish("");
      toast.success(t("Allergy created successfully"));
      navigate("/allergy");
    }
  }, [isSuccess]);

  return (
    <Card
      title={
        <Flex align="center" gap="middle" wrap>
          <span>{`${t("ALLERGY")} ${t("CREATE")}`}</span>
          {/* ✅ Add LocationSelector */}
          <LocationSelector onLocationChange={handleLocationChange} />
        </Flex>
      }
      className="allergy-create-page"
      extra={
        <Flex justify="center" gap={10}>
          <Button onClick={() => navigate("/allergy")}>{t("CANCEL")}</Button>
          <Button 
            type="primary" 
            onClick={handleCreateAllergy}
            loading={isLoading}
            disabled={!locationId}
          >
            {t("SAVE")}
          </Button>
        </Flex>
      }
    >
      <div className="allergy-create-page-container">
        <div className="allergy-create-page-container-dish">
          <div>{t("DISH")}</div>
          <Input
            style={{ flex: "1" }}
            value={allergyDish}
            onChange={(e) => setAllergyDish(e.target.value)}
            placeholder={locationId ? t("Enter dish name") : t("Please select a location first")}
            disabled={!locationId}
          />
        </div>
        <div className="allergy-create-page-container-allergy">
          <div className="allergy-create-page-container-allergy-label">
            {t("ALLERGY")}
          </div>
          <div className="allergy-create-page-container-allergy-grid">
            <div className="allergy-create-page-container-allergy-grid-item">
              {allergyType.slice(0, 7).map((item, key) => (
                <div
                  key={key}
                  className="allergy-create-page-container-allergy-grid-item"
                >
                  <Checkbox
                    checked={allergyUpdate.includes(item) ? true : false}
                    onClick={(cbox) => {
                      cbox.target.checked
                        ? setAllergyUpdate((e) => [...e, item])
                        : setAllergyUpdate((e) =>
                            e.filter((aItem) => aItem !== item)
                          );
                    }}
                    disabled={!locationId}
                  >
                    {t(item.toUpperCase())}
                  </Checkbox>
                </div>
              ))}
            </div>
            <div className="allergy-create-page-container-allergy-grid-item">
              {allergyType.slice(7, 14).map((item, key) => (
                <div
                  key={key}
                  className="allergy-create-page-container-allergy-grid-item"
                >
                  <Checkbox
                    checked={allergyUpdate.includes(item) ? true : false}
                    onClick={(cbox) =>
                      cbox.target.checked
                        ? setAllergyUpdate((e) => [...e, item])
                        : setAllergyUpdate((e) =>
                            e.filter((aItem) => aItem !== item)
                          )
                    }
                    disabled={!locationId}
                  >
                    {t(item.toUpperCase())}
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="allergy-create-page-container-button">
          <Button 
            type="primary" 
            onClick={handleCreateAllergy}
            loading={isLoading}
            disabled={!locationId}
          >
            {t("SAVE")}
          </Button>
        </div>
      </div>
    </Card>
  );
}